var exports = {
  "k": "xa15a2ab7--1b55db--container",
  "S": "xa15a2ab7--1b55db--play-button",
};

module.exports = exports;
